import { ReactComponent as TachoSyncLogo } from "../../assets/logos/TACHO_SYNC.svg";

const Logo = ({ ...props }) => {
  return <TachoSyncLogo {...props} data-testid="tacho-web-logo" />;
};

export default Logo;
